import '../scss/style.scss';
import '../scss/tailwind.css';
import '@fancyapps/ui/dist/fancybox/fancybox.css';
import { Fancybox } from '@fancyapps/ui/dist/fancybox/';

import './header';
import './accordion';
import './swiper-feature-block';
import './row-slider';
import './blog-posts-categories-slider';
import './handle-dynamic-img';
import './tabs-slider-swiper';
import './collapse-table';
import './collapse-table-comparative';
import './share-links';
import './custom-dropdown';
import './get-vehicles';
import './simulator';
import './clipboard';
import './category-loader';
// import './slider-logos';
import './slider-locations';

Fancybox.bind('[data-fancybox]', {});

// Scroll animations - detect when elements enter viewport
function initScrollAnimations() {
    const animatedElements = document.querySelectorAll('[data-animate]');

    if (animatedElements.length === 0) return;

    const observerOptions = {
        threshold: 0.1, // Much lower threshold for better mobile detection
        rootMargin: '0px 0px -10px 0px' // Less restrictive margin
    };

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const element = entry.target;
                const animationType = element.getAttribute('data-animate');
                const delay = element.getAttribute('data-delay') || '';

                // Add animation class
                element.classList.add(animationType);

                // Add delay if specified
                if (delay) {
                    element.classList.add(delay);
                }

                // Stop observing this element
                observer.unobserve(element);
            }
        });
    }, observerOptions);

    // Start observing all animated elements
    animatedElements.forEach(element => {
        observer.observe(element);
    });
}

// Initialize scroll animations when DOM is ready
document.addEventListener('DOMContentLoaded', initScrollAnimations);
